module.exports = __webpack_public_path__ + "images/404-bg.6869958195.png";